import { LogLevel, ILog } from '@agoda/messaging-client';
import { AppConfiguration } from 'core/configuration/AppConfiguration';
import { href as windowLocationHref, hostname as windowLocationHostname } from 'core-framework/window/location';
import { MessageType } from 'core/messaging/Messaging.types';
import { ActivitiesMessagingClient } from 'core/messaging/ActivitiesMessagingClient';
import { getBootstrapConfig, getIsJestTest } from 'core/window/windowService';
import { LogEventLevel } from 'core/messaging/logger/LogEventLevel';

export function debug(message: string, errorObj?: Error, tags?: object, eventData?: object) {
    // eslint-disable-next-line no-restricted-syntax
    if (shouldPrintLog()) console.log(message, errorObj);
    log(LogEventLevel.Debug, message, errorObj, tags, eventData);
}

export function info(message: string, errorObj?: Error, tags?: object) {
    // eslint-disable-next-line no-restricted-syntax
    if (shouldPrintLog()) console.log(message, errorObj);
    log(LogEventLevel.Information, message, errorObj, tags);
}

export function warning(message: string, errorObj?: Error, tags?: object) {
    // eslint-disable-next-line no-restricted-syntax
    if (shouldPrintLog()) console.warn(message, errorObj);
    log(LogEventLevel.Warning, message, errorObj, tags);
}

export function error(message: string, errorObj?: Error, tags?: object, eventData?: object) {
    if (shouldPrintLog()) console.error(message, errorObj);
    log(LogEventLevel.Error, message, errorObj, tags, eventData);
}

export function fatal(message: string, errorObj?: Error, tags?: object) {
    if (shouldPrintLog()) console.error(message, errorObj);
    log(LogEventLevel.Fatal, message, errorObj, tags);
}

export function log(level: LogLevel, message: string, errorObj?: Error, tags?: object, eventData?: object) {
    const config = getBootstrapConfig();
    const messageContext = {
        level,
        message,
        applicationName: 'activities',
        exceptionMessage: errorObj ? errorObj.message : undefined,
        exceptionType: errorObj ? errorObj.name : undefined,
        stack: errorObj ? errorObj.stack : undefined,
        url: windowLocationHref(),
        stringTags: (tags || errorObj) && { ...tags, stack: errorObj && errorObj.stack },
        sessionId: config.sessionId?.toString(),
        botName: config.requestProfile?.knownBotName || 'na',
        version: AppConfiguration.version,
        eventdata: { ...eventData },
    } as ILog;

    const msg = ActivitiesMessagingClient.create(MessageType.Log, messageContext);
    ActivitiesMessagingClient.send(msg);
}

function shouldPrintLog() {
    const isJestTest = getIsJestTest();
    if (isJestTest) {
        return false;
    }
    return !AppConfiguration.isProduction() || windowLocationHostname().indexOf('pl.agoda.com') > 0;
}
